/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';

declare global {
  interface Window {
    digitalData: DigitalData;
  }
}

export type DigitalData = {
  blockDDRW: boolean;
  page: {
    pageInfo: {
      pageName: string;
      experience?: string;
      pageNameDetailed?: string;
    };
    category: {
      pageType: string;
      primaryCategory: string;
      subCategory1: string;
      subCategory2: string;
      subCategory3?: string;
    };
  };
};

/**
 * builds the digitalData payload for tag manager as described in
 * https://chegg.atlassian.net/wiki/spaces/MT/pages/1926091/2.+Digital+Data+Layer+Reference
 * https://docs.google.com/spreadsheets/d/1Vf6VOKn7RVgLel8oSpQ9yEe74MgL96Pr3S4JWStc-Ho/edit?usp=sharing
 */
function updatedDigitalData(page: string): DigitalData {
  let payload: DigitalData;

  if (window.digitalData) {
    payload = { ...window.digitalData };
  } else {
    payload = {
      blockDDRW: true,
      page: {
        pageInfo: {
          pageName: '',
        },
        category: {
          pageType: 'auth',
          primaryCategory: 'chegg',
          subCategory1: 'web',
          subCategory2: 'core',
        },
      },
    };
  }

  switch (page) {
    case 'auth':
      payload.blockDDRW = true;
      payload.page = {
        ...payload.page,
        category: {
          ...payload.page.category,
          pageType: 'core',
          primaryCategory: 'chegg',
          subCategory1: 'web',
          subCategory2: 'core',
        },
        pageInfo: {
          ...payload.page.pageInfo,
          experience: 'desktop',
          pageName: 'Auth page',
        },
      };
      break;
    case 'signout':
      payload.blockDDRW = true;
      payload.page = {
        ...payload.page,
        category: {
          ...payload.page.category,
          pageType: 'core',
          primaryCategory: 'chegg',
          subCategory1: 'web',
          subCategory2: 'core',
        },
        pageInfo: {
          ...payload.page.pageInfo,
          experience: 'desktop',
          pageName: 'Sign Out',
        },
      };
      break;
    case 'resetpassword':
      payload.blockDDRW = true;
      payload.page = {
        ...payload.page,
        category: {
          ...payload.page.category,
          pageType: 'myAccout',
          primaryCategory: 'chegg',
          subCategory1: 'web',
          subCategory2: 'core',
        },
        pageInfo: {
          ...payload.page.pageInfo,
          experience: 'desktop',
          pageName: 'Reset Password',
        },
      };
      break;
  }
  return payload;
}

export function useDigitalData(page: 'auth' | 'signout' | 'resetpassword') {
  useEffect(() => {
    window.digitalData = updatedDigitalData(page);
  }, [page]);
}
